import { ITask } from "../../../../types/Task/Task.interface";
import { TaskStatus } from "../../../pages/Tasks/MyTasks/utils/constants";

export const isAllTasksCompleted = (tasks: ITask[]): boolean => {
  if (!tasks.length) return false;
  return tasks.every((task) => task.status === TaskStatus.COMPLETED);
};
